// @ts-nocheck
import { css } from "@emotion/react";

import LedCounter from "./led_counter-7.woff2";

export default css`
  @font-face {
    font-family: "Led Counter";
    src: local("Led Counter"), url(${LedCounter}) format("woff2");
  }
`;
